export class FunctionPerformed {
  functionPerformedId: number;
  name: string;
  group?: string;
}
